import { _ as _nativeCreate } from "./auth-service-tools1348.js";
var nativeCreate = _nativeCreate;

function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;
export { _hashClear as _ };